// Focus visible polyfill and management
(function () {
  "use strict";

  // Track if the user is using keyboard navigation
  let hadKeyboardEvent = true;
  let keyboardThrottleTimeout = null;

  const keyboardOnlyFocusHandler = () => {
    hadKeyboardEvent = false;
    if (keyboardThrottleTimeout) {
      clearTimeout(keyboardThrottleTimeout);
    }
    keyboardThrottleTimeout = setTimeout(() => {
      hadKeyboardEvent = true;
    }, 100);
  };

  const pointerEvent = (e) => {
    hadKeyboardEvent = false;
  };

  const focusTriggered = (e) => {
    if (hadKeyboardEvent || e.target.matches(":focus-visible")) {
      e.target.classList.add("focus-visible");
    } else {
      e.target.classList.remove("focus-visible");
    }
  };

  const blurTriggered = (e) => {
    e.target.classList.remove("focus-visible");
  };

  document.addEventListener("keydown", keyboardOnlyFocusHandler, true);
  document.addEventListener("mousedown", pointerEvent, true);
  document.addEventListener("pointerdown", pointerEvent, true);
  document.addEventListener("touchstart", pointerEvent, true);
  document.addEventListener("focus", focusTriggered, true);
  document.addEventListener("blur", blurTriggered, true);

  // Initialize the state based on the initial focus
  if (document.activeElement && document.activeElement !== document.body) {
    focusTriggered({ target: document.activeElement });
  }

  // Remove problematic ARIA roles from Slick dots
  const removeSlickRoles = () => {
    const slickDots = document.querySelectorAll(
      ".slick-dots li, .slick-dots li button"
    );
    slickDots.forEach((element) => {
      element.removeAttribute("role");
      element.setAttribute("tabindex", "-1");
      element.setAttribute("aria-hidden", "true");
    });
  };

  // Run on DOM load and mutations
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", removeSlickRoles);
  } else {
    removeSlickRoles();
  }

  // Also run when new content is added (for AJAX updates)
  const observer = new MutationObserver(() => {
    removeSlickRoles();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener("DOMContentLoaded", function () {
  // First, ensure jQuery is loaded
  if (
    typeof $ === "undefined" &&
    !document.querySelector('script[src*="jquery"]')
  ) {
    const jqueryScript = document.createElement("script");
    jqueryScript.src = "https://code.jquery.com/jquery-3.6.0.min.js";
    jqueryScript.onload = loadSlick;
    document.head.appendChild(jqueryScript);
  } else {
    loadSlick();
  }

  function loadSlick() {
    // Then load Slick carousel
    if (!document.querySelector('script[src*="slick.min.js"]')) {
      const slickScript = document.createElement("script");
      slickScript.src =
        "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
      slickScript.onload = initSlickCarousel;
      document.head.appendChild(slickScript);
    } else {
      initSlickCarousel();
    }
  }

  function initSlickCarousel() {
    // Wait a bit to ensure all scripts are fully loaded
    setTimeout(function () {
      if (typeof $ !== "undefined" && $.fn.slick) {
        // Initialize main product images carousel
        const carousel = $(".product-images-carousel");
        const slideCount = carousel.find(".product-image-slide").length;

        carousel.slick({
          dots: slideCount > 1,
          infinite: slideCount > 1,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          arrows: slideCount > 1,
          swipeToSlide: false,
          touchMove: true,
          useCSS: false,
          useTransform: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: slideCount > 1,
              },
            },
          ],
        });

        // Fix translation issues by forcing position recalculation
        if (slideCount > 1) {
          setTimeout(() => {
            carousel.slick("setPosition");
            // Force slide width recalculation
            carousel.slick("refresh");
          }, 100);

          // Additional fix for width calculation timing
          setTimeout(() => {
            carousel.slick("setPosition");
          }, 200);
        }

        // Initialize related products carousel (mobile only)
        const relatedCarousel = $(".related-products-carousel");
        const relatedSlideCount = relatedCarousel.find(
          ".related-product-slide"
        ).length;

        if (relatedSlideCount > 0) {
          relatedCarousel.slick({
            dots: false,
            infinite: relatedSlideCount > 1,
            speed: 300,
            slidesToShow: 1.2,
            slidesToScroll: 1,
            arrows: false,
            swipeToSlide: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            responsive: [
              {
                breakpoint: 9999,
                settings: "unslick",
              },
              {
                breakpoint: 768,
                settings: {
                  dots: false,
                  infinite: relatedSlideCount > 1,
                  arrows: false,
                  slidesToShow: 1.2,
                  slidesToScroll: 1,
                  swipeToSlide: true,
                  touchMove: true,
                },
              },
            ],
          });
        }
      }
    }, 100);
  }

  // Handle window resize for related products carousel
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (typeof $ !== "undefined" && $.fn.slick) {
        const relatedCarousel = $(".related-products-carousel");
        if (relatedCarousel.hasClass("slick-initialized")) {
          relatedCarousel.slick("resize");
        }
      }
    }, 250);
  });

  // Initialize variant selector
  initVariantSelector();

  // Initialize product drawers and modals
  initProductDrawers();
  initSizeChartDrawer();

  function initVariantSelector() {
    const variantButtons = document.querySelectorAll(".variant-option");
    const variantIdInput = document.querySelector(".variant-id-input");
    const priceElement = document.querySelector(
      ".product-info div:nth-child(2)"
    );

    variantButtons.forEach((button) => {
      button.addEventListener("click", function () {
        // Remove selected class and aria-checked from all buttons
        variantButtons.forEach((btn) => {
          btn.classList.remove("selected", "font-bold");
          btn.setAttribute("aria-checked", "false");
        });

        // Add selected class to clicked button
        this.classList.add("selected", "font-bold");
        this.setAttribute("aria-checked", "true");

        // Update hidden input with selected variant ID
        const variantId = this.getAttribute("data-variant-id");
        const variantPrice = this.getAttribute("data-variant-price");

        if (variantIdInput) {
          variantIdInput.value = variantId;
        }

        // Update price display
        if (priceElement && variantPrice) {
          priceElement.textContent = variantPrice;
          // Update aria-label for price
          priceElement.setAttribute("aria-label", `Price: ${variantPrice}`);
        }

        // Announce variant selection to screen readers
        const variantTitle = this.textContent.trim();
        announceToScreenReader(
          `Selected variant: ${variantTitle}, ${variantPrice || ""}`
        );

        // Update fieldset aria-activedescendant
        const fieldset = this.closest("fieldset");
        if (fieldset) {
          fieldset.setAttribute("aria-activedescendant", this.id || "");
        }

        // Update add to cart button based on variant availability
        const addToCartButton = document.querySelector('button[type="submit"]');
        const isAvailable = !this.hasAttribute("disabled");

        if (addToCartButton) {
          if (isAvailable) {
            addToCartButton.disabled = false;
            addToCartButton.textContent = "ADD TO CART";
            addToCartButton.className =
              "btn w-max cursor-pointer bg-black px-3 py-1 text-white hover:bg-gray-800 transition-colors duration-200";
          } else {
            addToCartButton.disabled = true;
            addToCartButton.textContent = "SOLD OUT";
            addToCartButton.className =
              "btn w-max cursor-not-allowed bg-gray-400 px-3 py-1 text-white";
          }
        }
      });

      // Add keyboard navigation
      button.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }

        // Arrow key navigation
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          let nextButton = this.nextElementSibling;
          if (!nextButton) {
            nextButton = variantButtons[0]; // Loop to first
          }
          nextButton.focus();
        }

        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          let prevButton = this.previousElementSibling;
          if (!prevButton) {
            prevButton = variantButtons[variantButtons.length - 1]; // Loop to last
          }
          prevButton.focus();
        }
      });
    });
  }

  // Accessibility helper function
  function announceToScreenReader(message) {
    const announcement = document.createElement("div");
    announcement.setAttribute("aria-live", "polite");
    announcement.setAttribute("aria-atomic", "true");
    announcement.className = "sr-only";
    announcement.textContent = message;
    document.body.appendChild(announcement);

    setTimeout(() => {
      if (document.body.contains(announcement)) {
        document.body.removeChild(announcement);
      }
    }, 1000);
  }

  function initProductDrawers() {
    const drawerToggles = document.querySelectorAll(".drawer-toggle");

    drawerToggles.forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const drawerId = this.getAttribute("data-drawer");
        const content = document.querySelector(
          `[data-drawer-content="${drawerId}"]`
        );
        const arrow = this.querySelector(".drawer-arrow");

        if (content && arrow) {
          const isOpen = !content.classList.contains("hidden");

          if (isOpen) {
            // Close drawer
            content.classList.add("hidden");
            arrow.classList.remove("rotate-180");
          } else {
            // Open drawer
            content.classList.remove("hidden");
            arrow.classList.add("rotate-180");
          }
        }
      });
    });
  }

  function initSizeChartDrawer() {
    const sizeChartButton = document.querySelector(".size-chart-button");
    const drawer = document.querySelector(".size-chart-drawer");
    const overlay = document.querySelector(".size-chart-overlay");
    const closeButton = document.querySelector(".size-chart-close");

    function openSizeChart() {
      drawer.classList.remove("translate-x-full");
      drawer.classList.add("translate-x-0");
      overlay.style.display = "block";
      document.body.style.overflow = "hidden";
    }

    function closeSizeChart() {
      drawer.classList.remove("translate-x-0");
      drawer.classList.add("translate-x-full");
      overlay.style.display = "none";
      document.body.style.overflow = "";
    }

    if (sizeChartButton && drawer) {
      // Open drawer when button is clicked
      sizeChartButton.addEventListener("click", openSizeChart);

      // Close drawer when close button is clicked
      if (closeButton) {
        closeButton.addEventListener("click", closeSizeChart);
      }

      // Close drawer when overlay is clicked
      if (overlay) {
        overlay.addEventListener("click", closeSizeChart);
      }

      // Close drawer on Escape key press
      document.addEventListener("keydown", function (e) {
        if (
          e.key === "Escape" &&
          !drawer.classList.contains("translate-x-full")
        ) {
          closeSizeChart();
        }
      });
    }
  }

  // Add to Cart functionality
  initAddToCart();

  function initAddToCart() {
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const addToCartButton = this.querySelector('button[type="submit"]');

        // Disable button and show loading state
        if (addToCartButton) {
          addToCartButton.disabled = true;
          addToCartButton.textContent = "ADDING...";
        }

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((item) => {
            // Open cart drawer after adding item
            const cartDrawer = document.querySelector(".cart-drawer");
            const cartOverlay = document.querySelector(".cart-drawer-overlay");

            if (cartDrawer && cartOverlay) {
              cartDrawer.classList.remove("translate-x-full");
              cartDrawer.classList.add("translate-x-0");
              cartOverlay.style.display = "block";
              document.body.style.overflow = "hidden";
            }

            // Refresh cart drawer content without page reload
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                updateCartDrawerContent(cart);
              });
          })
          .catch((error) => {
            console.error("Error adding to cart:", error);
            alert(
              "Sorry, there was an error adding this item to your cart. Please try again."
            );
          })
          .finally(() => {
            // Re-enable button
            if (addToCartButton) {
              addToCartButton.disabled = false;
              addToCartButton.textContent = "ADD TO CART";
            }
          });
      });
    }
  }

  // Function to update cart drawer content without page reload
  function updateCartDrawerContent(cart) {
    // Update subtotal
    const subtotal = document.getElementById("cart-subtotal");
    if (subtotal) {
      subtotal.textContent = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(cart.total_price / 100);
    }

    // Show/hide cart items list and empty state based on item count
    const cartItemsList = document.querySelector(".cart-items-list");
    const cartEmptyState = document.querySelector(".cart-empty-state");
    const cartFooter = document.querySelector(".cart-drawer-footer");

    if (cart.item_count > 0) {
      if (cartItemsList) cartItemsList.classList.remove("hidden");
      if (cartEmptyState) cartEmptyState.classList.add("hidden");
      if (cartFooter) cartFooter.classList.remove("hidden");
    } else {
      if (cartItemsList) cartItemsList.classList.add("hidden");
      if (cartEmptyState) cartEmptyState.classList.remove("hidden");
      if (cartFooter) cartFooter.classList.add("hidden");
    }

    // Check if drawer is open and keep it open
    const cartDrawer = document.querySelector(".cart-drawer");
    const cartOverlay = document.querySelector(".cart-drawer-overlay");
    const isDrawerOpen =
      cartDrawer && !cartDrawer.classList.contains("translate-x-full");

    // Fetch fresh cart HTML and update the drawer
    fetch("/?sections=header")
      .then((response) => response.json())
      .then((data) => {
        if (data.header) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data.header, "text/html");
          const newCartItems = doc.getElementById("cart-drawer-items");
          const newCartFooter = doc.querySelector(".cart-drawer-footer");

          // Update cart items
          const currentCartItems = document.getElementById("cart-drawer-items");
          if (newCartItems && currentCartItems) {
            currentCartItems.innerHTML = newCartItems.innerHTML;
          }

          // Update cart footer (subtotal and buttons)
          const currentCartFooter = document.querySelector(
            ".cart-drawer-footer"
          );
          if (newCartFooter && currentCartFooter) {
            currentCartFooter.innerHTML = newCartFooter.innerHTML;
          }

          // Re-apply visibility based on cart state
          const updatedCartItemsList =
            document.querySelector(".cart-items-list");
          const updatedCartEmptyState =
            document.querySelector(".cart-empty-state");
          const updatedCartFooter = document.querySelector(
            ".cart-drawer-footer"
          );

          if (cart.item_count > 0) {
            if (updatedCartItemsList)
              updatedCartItemsList.classList.remove("hidden");
            if (updatedCartEmptyState)
              updatedCartEmptyState.classList.add("hidden");
            if (updatedCartFooter) updatedCartFooter.classList.remove("hidden");
          } else {
            if (updatedCartItemsList)
              updatedCartItemsList.classList.add("hidden");
            if (updatedCartEmptyState)
              updatedCartEmptyState.classList.remove("hidden");
            if (updatedCartFooter) updatedCartFooter.classList.add("hidden");
          }

          // Keep drawer open if it was open
          if (isDrawerOpen && cartDrawer && cartOverlay) {
            cartDrawer.classList.remove("translate-x-full");
            cartDrawer.classList.add("translate-x-0");
            cartOverlay.style.display = "block";
            document.body.style.overflow = "hidden";
          }
        }
      })
      .catch(() => {
        console.log(
          "Failed to update cart drawer, keeping it open without refresh"
        );
      });
  }

  // Make the function globally available for the header script
  window.updateCartDrawerContent = updateCartDrawerContent;
});
